import { useDispatch } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../common/html/element'
import { PopupAction } from '../../common/popup/PopupAction'
import { updateTopic } from '../store/thunk'

export const PopupDeleteHistoryChatbot = ({
  isShow,
  setShow,
  topicSelectDelete,
}) => {
  const dispatch = useDispatch()
  const onSubmit = () => {
    try {
      // const user = await authProvider.getUser()
      dispatch(
        updateTopic({
          TopicId: topicSelectDelete?.topicId,
          Status: 'InActive',
        }),
      )
    } finally {
      setShow(false)
    }
  }

  return (
    <>
      {isShow && (
        <PopupAction
          isShow={isShow}
          title="chatbot.DELETE_SESSION"
          handleClose={() => setShow(false)}
          btnSubmit={{
            label: 'common.DELETE',
            isI18n: true,
            event: (e) => {
              e.stopPropagation()
              onSubmit()
            },
          }}
          btnCancel={{
            label: 'common.CANCEL',
            isI18n: true,
            event: (e) => {
              e.stopPropagation()
              setShow(false)
            },
          }}
        >
          <Element elementName="p" style={{ overflowWrap: 'break-word' }}>
            <Translate
              value="chatbot.DELETE_SESSION_DES"
              sessionName={topicSelectDelete?.topicTitle}
            />
          </Element>
        </PopupAction>
      )}
    </>
  )
}
